import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// @material-ui
import { Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { findInObject } from '_core/utils/findInObject'
import { useRequest } from '_core/hooks/useRequest'
import { withLang } from '_core/hocs/withLang'
import { withCatch } from '_core/hocs/withCatch'
import { useCartContext } from '_core/contexts/Cart';
import { State } from '_core/components/State'
import SimpleCard from '_core/components/SimpleCard/SimpleCard'

import {
  privateDataActions,
  privateDataSelectors,
} from '_core/store/PrivateData'

// style
import { statsFinanceStyle } from './statsFinanceStyle'

import { API_METHOD } from 'basic/config'


const mapState = state => ({
  investStat: privateDataSelectors.getInvestmentStat(state),
})

const mapDispatch = {
  updateInvestmentStat: privateDataActions.updateInvestmentStat,
}


const RawStatsFinance = (props) => {
  const {
    // classes,
    investStat,
    getLangString: l,
    updateInvestmentStat
  } = props

  const cart = useCartContext();

  const { queue } = useRequest()
  const [nodeKey, setNodeKey] = useState(0)

  const getInvestStat = async () =>
    investStat != null
      ? investStat
      : await queue(API_METHOD.INVESTMENT_STAT, { currency: cart.currency.id }).then(updateInvestmentStat);

  useEffect(() => {
    setNodeKey(nk => nk + 1)
  }, [cart.currency])

  const getCurrencyData = amount =>
    findInObject(cart.currencyList, 'id', amount.currency.id)

  return (
    <State
      key={nodeKey}
      waitProps={{ currencies: cart.currencyList }}
      getProps={{ investStat: getInvestStat }}
      render={({ investStat }) => (
        <Grid container={true}>
          <Grid item={true} xs={12} sm={4}>
            <SimpleCard
              elevation={12}
              icon="payment"
              title={l('r.obyem.aktivnyh.investiciy')}
              value={investStat.lo.value}
              currency={getCurrencyData(investStat.lo)}
              format={true}
              // modal={
              //   <Shareholding
              //     currency={getCurrencyData(investStat.lo)}
              //   />
              // }
            />
          </Grid>

          <Grid item={true} xs={12} sm={4}>
            <SimpleCard
              elevation={12}
              icon="vertical_align_bottom"
              title={l('r.poluchenye.dividendy.po.investiciyam')}
              value={investStat.dohod.value}
              currency={getCurrencyData(investStat.dohod)}
              format={true}
              // modal={
              //   <Dividends
              //     currency={getCurrencyData(investStat.dohod)}
              //   />
              // }
              modalMaxWidth="xs"
            />
          </Grid>

          <Grid item={true} xs={12} sm={4}>
            <SimpleCard
              elevation={12}
              icon="supervisor_account"
              title={l('r.dohod.po.partnerke')}
              value={investStat.bonus.value}
              currency={getCurrencyData(investStat.bonus)}
              format={true}
              // modal={
              //   <AffiliateProgram
              //     currency={getCurrencyData(investStat.bonus)}
              //   />
              // }
              modalMaxWidth="xs"
            />
          </Grid>
        </Grid>
      )}
    />
  )
}

RawStatsFinance.defaultProps = {}

RawStatsFinance.propTypes = {
  // `redux-connect` HOC props
  investStat: PropTypes.object,
  updateInvestmentStat: PropTypes.func.isRequired,

  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const StatsFinance = withCatch(
  withLang(
    connect(
      mapState,
      mapDispatch
    )(withStyles(statsFinanceStyle)(RawStatsFinance))
  )
)
